import React, {useState, useEffect, useRef} from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { Button } from 'primereact/button';
import { gql, useMutation } from '@apollo/client';
import Partner from './Partner';
import { useDispatch, useSelector } from 'react-redux';
import { resetCurrentDomain, resetCurrentPreset, setCurrentCustomer, setNavigationMode } from '../reducers/userLoginReducer';
import { getIn } from '../utilities/utils';
/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";

const PARTNER_MUTATION = gql`
  mutation callpartnerInfoMutation($id: String, $role: String) {
    partnerInfoMutation(input: {id: $id, role: $role}) {
        clientMutationId
        partnerName
        customerInfo
    }
  }
`

const CustomerInfo = (props) => {
    const dispatch = useDispatch()
    const { currentCustomer } = useSelector(state => state.userInformation)
    const [mutationData, setMutationData] = useState(null)
    const [PARTNER_MUTATION_CONTAINER] = useMutation(
        PARTNER_MUTATION,
        {
            onCompleted(data) {
		confirm(data)
            }
        }
    );

    const dt = useRef(null);

    useEffect(() => {
        dispatch(resetCurrentPreset())
        dispatch(resetCurrentDomain())
        dispatch(setNavigationMode('domain'))
        PARTNER_MUTATION_CONTAINER({
            variables: { id: currentCustomer, role: 'administrator' }
        })
    }, [currentCustomer])

    const exportCSV = (selectionOnly) => {
        dt.current.exportCSV({ selectionOnly });
    };

    const confirm = data => {
        let customerInfo = JSON.parse(getIn(data, 'partnerInfoMutation', 'customerInfo'))
        customerInfo.sort((c1, c2) => c1.title.localeCompare(c2.title))
        const assignedClients = JSON.parse(localStorage.getItem('assignedClients')) || []
        if (assignedClients.length >= 2) {
            customerInfo = customerInfo.filter(({id}) => assignedClients.includes(id))
        }

        setMutationData(customerInfo.map(data=> {
            if (data.domainsInfo) {
                data.domainsInfo = data.domainsInfo.map((domain, index) => `${index+1}.${domain.post_title}`).join("\n");
            }

            return data;
        }));
    }

    const DomainInfoCell = ({ rowData }) => {
        const [isExpanded, setIsExpanded] = React.useState(false);

        // 1. Get the pre-existing count from rowData.domains
        const totalCount = parseInt(rowData.domains);

        // 2. Parse the string for display
        // We split by numbers followed by dots to get the clean domain names
        const allDomains = rowData.domainsInfo
            ? rowData.domainsInfo.split(/\d+\./).map(d => d.trim()).filter(Boolean)
            : [];

        const limit = 3;
        const hasMore = totalCount > limit;

        // 3. Slice the array based on state
        const displayedDomains = isExpanded ? allDomains : allDomains.slice(0, limit);

        return (
            <div style={{ minWidth: '200px' }}>
                <ul style={{ listStyle: 'none', padding: 0, margin: 0 }}>
                    {displayedDomains.map((domain, index) => (
                        <li key={index} style={{ fontSize: '0.85rem', marginBottom: '2px' }}>
                            {index + 1}. {domain}
                        </li>
                    ))}
                </ul>

                {hasMore && (
                    <button
                        type="button"
                        onClick={() => setIsExpanded(!isExpanded)}
                        style={{
                            color: '#2196F3',
                            cursor: 'pointer',
                            border: 'none',
                            background: 'none',
                            padding: '2px 0',
                            fontSize: '0.75rem',
                            fontWeight: '600'
                        }}
                    >
                        {isExpanded ? 'Show less' : `... and ${totalCount - limit} more`}
                    </button>
                )}
            </div>
        );
    };

    const actionBodyTemplate = (rowData) => {
        return (
            <div className="actions">
                <Button icon="pi pi-globe" className="p-button-rounded p-button-success p-mr-2" onClick={() => editProduct(rowData)} label="Domains" />
            </div>
        );
    }

    const editProduct = (product) => {
        dispatch(setCurrentCustomer(product.id))
        props.history.push("/domains")
    }

    return (
        <>
            <Partner {...props} />
            <div className="layout-main">
                <div css={css`
                            width: 100%;
                            display: flex;
                            justify-content: right;
                            margin-bottom: 1em;
                        `}>
                    <Button label="Export CSV" type="button" icon="pi pi-download" rounded onClick={() => exportCSV(false)} data-pr-tooltip="CSV" />

                </div>
                {mutationData && (
                    <DataTable ref={dt} value={mutationData}>
                        <Column field="id" header="ID" className='p-d-none'></Column>
                        <Column field="title" header="Customer"></Column>
                        <Column field="type" header="Type"></Column>
                        <Column field="domains" header="Domains"></Column>
                        <Column body={(rowData) => <DomainInfoCell rowData={rowData} />} field="domainsInfo" header="Domains Names"></Column>
                        <Column field="users" header="Users"></Column>
                        <Column body={actionBodyTemplate}></Column>
                    </DataTable>
                )}
            </div>
        </>
    )
}

export default CustomerInfo;
